var path = 'areas/accounts/views/username_password_account.html';
var html = "<div> <control-group label=Username> <input class=form-control id=Username type=text placeholder=Username ng-model=account.Username> <p class=help-block>The username to use when authenticating against the remote host.</p> </control-group> <control-group label=Password> <sensitive-input model=account.Password id=Password></sensitive-input> <p class=help-block>The password to use to when authenticating against the remote host.</p> </control-group> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/views/username_password_account.html
// module id = 6080631229322108
// module chunks = 1